import { render } from "./ModalVoucher.vue?vue&type=template&id=c55ec318"
import script from "./ModalVoucher.vue?vue&type=script&lang=js"
export * from "./ModalVoucher.vue?vue&type=script&lang=js"

import exportComponent from "/media/dev/Develop/Projects/Sjef/kiosk.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__